import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withUnit from '../utils/with-unit';
import containsInstanceOf from '../common/utils/contains-instance-of';
import Render from '../render';
import PanelLeft from './panel-left';
import PanelRight from './panel-right';

const defaultStyles = {};

function Panel({
  height = 'auto',
  align = 'top',
  theme = 'white',
  scrollable = false,
  corners = 'rounded',
  children,
  className = '',
  style = defaultStyles,
  rootRef = null,
  draggablePanel = false,
  ...otherProps
}) {
  const classes = classNames(
    'ws-panel',
    `ws-panel--theme-${theme}`,
    `ws-panel--align-${align}`,
    `ws-panel--corners-${corners}`,
    className,
    {
      'ws-panel--scrollable': scrollable,
      'ws-panel--draggable': draggablePanel,
    }
  );

  const hasLeftRightPanel =
    containsInstanceOf(PanelLeft, children) || containsInstanceOf(PanelRight, children);

  return (
    <div
      className={classes}
      style={{ ...style, height: withUnit(height) }}
      ref={rootRef}
      {...otherProps}
    >
      <Render if={draggablePanel}>
        <div className="drag-element" />
      </Render>
      <Render if={hasLeftRightPanel}>{children}</Render>
      <Render if={!hasLeftRightPanel}>
        <div className="ws-panel__content">{children}</div>
      </Render>
    </div>
  );
}

Panel.propTypes = {
  rootRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.oneOf(['top', 'middle', 'bottom']),
  theme: PropTypes.oneOf(['white', 'gray-100']),
  className: PropTypes.string,
  scrollable: PropTypes.bool,
  corners: PropTypes.oneOf(['rounded', 'squared']),
  style: PropTypes.shape(),
  children: PropTypes.node.isRequired,
  draggablePanel: PropTypes.bool,
};

export default Panel;
